/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Grid, useTheme } from '@material-ui/core';

import { NotificationTypes, ICustomTheme } from 'interfaces';
import { Text } from 'components';
import { useSnackMessageEvents } from './use-snack-message-events.hooks';
import { Banner, StyledCard } from './SnackMessage.style';

export const SnackMessage: React.FC<NotificationTypes> = React.forwardRef(
  (props, ref) => {
    const { id, message } = props;
    const { variant, handleDismiss } = useSnackMessageEvents(id);
    const theme: ICustomTheme = useTheme();

    return (
      <StyledCard ref={ref}>
        <Grid container spacing={1}>
          <Grid item>
            <Banner variant={variant} />
          </Grid>
          <Grid item xs css={{ display: 'flex', alignItems: 'center' }}>
            <div css={{ padding: theme.spacing(1.5) }}>
              {message.split(';').map((text, index) => (
                <Text
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  text={text}
                  size="body2"
                  isParagraph={false}
                />
              ))}
            </div>
          </Grid>
          <Grid item>
            <IconButton onClick={handleDismiss}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </StyledCard>
    );
  },
);

export default SnackMessage;
